
const colorConfigs = {
  btn: {
    cancel: {
      bg: "#FFFFFF",
      color: "#EA8616",
      border: "1px solid #EA8616",
    },
    main: {
      bg: "#EA8616",
      tailwind: "bg-[#EA8616]"
    },
    delete: {
      bg: "#D92D20"
    }
  },
  color: {
    main: "#EA8616"
  },
  sidebar: {
    bg: "#ffffff",
    tailwindBg: "bg-white",
    color: "#58707b",
    hoverBg: "#eeeeee",
    activeBg: "rgba(105, 178, 232, 0.10)"
  },
  topbar: {
    bg: "#EA8616",
    color: "#FFFFFF"
  },
  jumper: {
    bg: "#EA8616",
  },
  mainBg: "#ffffff",
  primaryColor: "#EA8616",
};

export default colorConfigs;